import { render, staticRenderFns } from "./EditDepartmentsModal.vue?vue&type=template&id=5c8bd4d7&scoped=true&"
import script from "./EditDepartmentsModal.vue?vue&type=script&lang=js&"
export * from "./EditDepartmentsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditDepartmentsModal.vue?vue&type=style&index=0&id=5c8bd4d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8bd4d7",
  null
  
)

export default component.exports